export const BookingsByPaymentDates = {
  en: {
    'Paid Bookings By Payment Dates': 'Paid Bookings By Payment Dates',
    Date: 'Date',
    Count: 'Count',
    From: 'From',
    Till: 'Till (Not Including)',
    'No Data Provided': 'No Data Provided',
  },
  uk: {
    'Paid Bookings By Payment Dates': 'Сплачені бронювання по датах платежів',
    Date: 'Дата',
    Count: 'Кількість',
    From: 'Від',
    Till: 'До (Не включаючи)',
    'No Data Provided': 'Дані відсутні',
  },
};
